import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData, getTablebySql } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnGrid from "@shared/components/GridV2/SnGrid";

interface Props {
  Menuprops: menuInfo;
}

const SN_PUR_BAS_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const sharedFormRef1 = useRef<any>();

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const [sharedForm, setSharedForm] = useState<any[]>([]);

  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [cdIoList, setCdIoList] = useState<any[]>([]); // onValueChaged 함수에서 수불형태 비교용 데이터

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums({
          grid1: rtn.grid.grid1,
        });
        const param = {
          id: "sn_pur_bas_reg_001_getcdio",
          params: { cd_firm: userInfo.cd_firm },
        };
        const rtn2: any = await fnGetDataSet(param);
        setCdIoList(rtn2[0]);
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const modifiedRows = gridRefs.current["grid1"].current.getChange();
      if (modifiedRows.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved = await onSave();
          if (!isSaved) return;
        }
      }

      const params = {
        id: "sn_pur_bas_reg_001_01",
        params: searchRef.current.getFormdata(),
      };

      setFocusedRowData(null);
      gridRefs.current["grid1"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    const newRow = {
      cd_firm: userInfo.cd_firm,
      cd_biz: userInfo.cd_biz,
      yn_use: "Y",
      cd_io: "",
      fg_trns: "1",
      fg_money: "1",
      yn_app: "N",
      yn_trade: "N",
      yn_autoreq: "N",
      yn_autorcv: "N",
      yn_autopur: "N",
      fg_um: "1",
      yn_grw: "N",
      tp_um_vat: "1",
    };
    gridRefs.current["grid1"].current?.addRow(newRow);
    // sharedFormRef1.current.focusInputByIndex(0);
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid1"].current.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onSave = async () => {
    let masPoTypeChanges;
    try {
      gridRefs.current["grid1"].current.stopEditing();

      const requiredValuesCheck =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheck) return false;

      masPoTypeChanges = gridRefs.current["grid1"].current.getChange();
      if (masPoTypeChanges.modifiedRowcount == 0) {
        await showDialog("alter", "저장할 내용이 없습니다.");
        return false;
      }

      const hasInvalidCdPo = [
        ...(masPoTypeChanges.insert || []),
        ...(masPoTypeChanges.update || []),
      ].some((item) => item.cd_po && item.cd_po.length > 6);
      if (hasInvalidCdPo) {
        await showDialog("alter", "발주형태코드가 6자리를 초과하였습니다.");
        return false;
      }

      const gridData: any[] = [];
      gridRefs.current["grid1"].current.forEachFilteredNode((node: any) => {
        gridData.push(node.data);
      });
      const List = new Set<string>();
      if (gridRefs.current["grid1"].current.getDisplayedRowCount() > 1) {
        for (let i = 0; i < gridData.length; i++) {
          const row = gridData[i];
          const Cd_po = row?.cd_po?.trim();
          if (!Cd_po) continue;

          if (List.has(Cd_po)) {
            await showDialog(
              "error",
              `[${Cd_po}]발주형태코드가 중복되었습니다.`
            );
            return false;
          }
          List.add(Cd_po);
        }
      }

      const savedPotype = masPoTypeChanges.insert;
      let cdPoList = "";
      for (let i = 0; i < savedPotype.length; i++) {
        cdPoList += savedPotype[i]?.cd_po + ",";
      }

      const sql = {
        sql: `select * from mas_cust where cd_firm = '${userInfo.cd_firm}' and (cd_cust in (select dc from fn_mas_split('${cdPoList}', ',')));`,
      };
      const data: any = await getTablebySql(sql);
      if (data[0]) {
        for (let i = 0; i < data.length; i++) {
          const duplicated = gridData.find(
            (row) => row.cd_po === data[i].cd_po
          );
          if (duplicated) {
            await showDialog(
              "error",
              `[${data[i].cd_po}]발주형태코드가 이미 등록되어 있습니다.`
            );
            return false;
          }
        }
      }

      const saveData = {
        mas_potype: masPoTypeChanges,
      };
      const ok = await fnSave("SN_PUR_BAS_REG_001_SAVE_01", saveData);
      if (!ok) return false;

      gridRefs.current["grid1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      return false;
    }
  };

  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );

  const onValueChaged = async (data: any, param: string, formData: any) => {
    switch (param) {
      // 거래구분
      case "fg_trns":
        return { yn_trade: data === "1" ? "N" : "Y" };
      // 수불형태
      case "cd_io":
        if (data === "") {
          return { fg_money: "1" };
        } else {
          const fg_money = cdIoList.find(
            (value) => value.cd_io === data
          )?.fg_money;
          return { fg_money: fg_money ? fg_money : "1" };
        }
      // 자동의뢰여부
      case "yn_autoreq":
        if (data === "Y") {
          if (formData.yn_app === "N") {
            return { yn_app: "Y" };
          }
        }
        return {};
      // 자동입고여부
      case "yn_autorcv":
        if (data === "Y") {
          let rtnData: any = {};
          if (formData.yn_app === "N") rtnData["yn_app"] = "Y";
          if (formData.yn_autoreq === "N") rtnData["yn_autoreq"] = "Y";
          return rtnData;
        }
        return {};
      // 자동매입여부
      case "yn_autopur":
        if (data === "Y") {
          let rtnData: any = {};
          if (formData.yn_app === "N") rtnData["yn_app"] = "Y";
          if (formData.yn_autoreq === "N") rtnData["yn_autoreq"] = "Y";
          if (formData.yn_autorcv === "N") rtnData["yn_autorcv"] = "Y";
          return rtnData;
        }
        return {};
      default:
        return {};
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="23.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "발주형태",
              isEditable: false,
            }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="76.5%">
          <SharedForm
            ref={sharedFormRef1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={gridRefs.current["grid1"]}
            title="상세정보"
            onValueChaged={onValueChaged}
          ></SharedForm>
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_PUR_BAS_REG_001;
